import { ProductStorefrontVisibility } from '@/lib/enums/ProductStorefrontVisibility'

interface VisibilityCollection {
  is_published?: boolean
}

/** The product fields that decide whether it shows in a visible collection. */
interface VisibilityProduct {
  storefront_visibility?: string | null
  collections?: (VisibilityCollection | null | undefined)[] | null
}

export function collectionsHaveVisibleCollection(
  collections: (VisibilityCollection | null | undefined)[] | null | undefined
): boolean {
  return Array.isArray(collections)
    ? collections.some((collection) => collection?.is_published === true)
    : false
}

export function productHasVisibleCollection(
  product: VisibilityProduct | null | undefined
): boolean {
  return collectionsHaveVisibleCollection(product?.collections)
}

/** Products shown only in visible collections need at least one. */
export function productNeedsVisibleCollection(
  product: VisibilityProduct | null | undefined
): boolean {
  return (
    product?.storefront_visibility === ProductStorefrontVisibility.PublishedCollection.Value &&
    !productHasVisibleCollection(product)
  )
}
